import { Button } from "@hub/components/ui/button";
import { apiFetch } from "@hub/ui/api";
import { RefreshCw } from "lucide-react";
import { useState } from "react";

/**
 * The manual trigger provisioning-an-instance.md and helm-operations.md's
 * "Resize" section both promise ("or a manual run, see below") -- it did not
 * exist (review finding 9/minor). Runs the SAME sweep the hourly timer runs
 * (POST /api/fleet/reconcile -> reconcileOnce), for an operator who does not
 * want to wait up to an hour, e.g. right after a resize to pull a moved
 * public IP into DNS immediately.
 *
 * A full reload on success, not local state -- this repo's console has no
 * client-side data layer to invalidate (see App.tsx's own note on why
 * navigation here is plain `<a>` tags and full document loads), and a
 * reconcile can change the drift banner, the fleet stats, and any row's
 * public IP all at once.
 */
export function ReconcileButton() {
  const [running, setRunning] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function run() {
    setRunning(true);
    setError(null);
    try {
      await apiFetch("/api/fleet/reconcile", { method: "POST" });
      window.location.reload();
    } catch (err) {
      setRunning(false);
      setError(err instanceof Error ? err.message : "reconcile failed");
    }
  }

  return (
    <div className="flex flex-col items-end gap-1">
      <Button variant="outline" onClick={run} disabled={running}>
        <RefreshCw className={running ? "animate-spin" : undefined} />
        {running ? "Reconciling…" : "Reconcile now"}
      </Button>
      {error ? <p className="text-xs text-destructive">{error}</p> : null}
    </div>
  );
}
